// Generated from api/openapi/agents.yaml by make docs. Do not edit.
import { z } from "zod";
import { principalRefSchema } from "@pureid/auth-core";

export const approvalHistoryRowSchema = z.object({
  "approval_id": z.string().uuid(),
  "auth_req_id": z.string(),
  "agent_id": z.string().uuid(),
  "agent_name": z.string().optional(),
  "grant_jti": z.string().uuid(),
  "approver": principalRefSchema.optional(),
  "human_sub": z.string().uuid(),
  "summary": z.string().optional(),
  "consequence": z.object({
    "measurements": z.array(z.object({
      "dimension": z.string(),
      "quantity": z.number().int()
    }).strict()).optional()
  }).strict(),
  "resource": z.string().optional(),
  "status": z.enum(["pending", "approved", "denied", "expired", "consumed"]),
  "created_at": z.string().datetime({ offset: true }),
  "decided_at": z.string().datetime({ offset: true }).optional()
}).strict();

export const approvalHistoryResponseSchema = z.object({
  "approvals": z.array(approvalHistoryRowSchema),
  "total": z.number().int()
}).strict();
